import React, { useState } from 'react';

const TestimonialTwo = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleMouseOver = (index) => {
    setActiveIndex(index);
  };

  return (
    <section className="testimonial-area2 overflow-hidden space" id="testi-sec">
      <div className="container shape-mockup-wrap">
        <div className="title-area text-center">
          <span className="sub-title">Testimonial</span>
          <h2 className="sec-title">What Client Say About us</h2>
        </div>

        <div className="row justify-content-center">
          <div className="col-xl-12">
            <div className="testi-review" style={{ backgroundImage: "url('/assets/img/bg/map.png')" }}>
              {/* Testimonial 1 */}
              <div
                className={`testi-box hover-item ${activeIndex === 0 ? 'item-active' : ''}`}
                onMouseOver={() => handleMouseOver(0)}
              >
                <div className="testi-box_content feature-card-active-wrap">
                  <p className="testi-box_text">
                    "Himolan Peak Adventures gave us the most memorable trip to Skardu. The blossom season was absolutely magical, and our guide Zahid was incredibly professional and knowledgeable."
                  </p>
                  <div className="testi-box_review">
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                  </div>
                </div>
                <div className="testi-box_profile">
                  <div className="testi-box_avater">
                    <span></span>
                    <img src="/assets/img/testimonial/testi_2_1.png" alt="testimonial" />
                  </div>
                  <div className="media-body">
                    <h3 className="box-title">Ahmad Raza</h3>
                    <span className="testi-box_desig">Lahore, Pakistan</span>
                  </div>
                </div>
              </div>

              {/* Testimonial 2 */}
              <div
                className={`testi-box hover-item ${activeIndex === 1 ? 'item-active' : ''}`}
                onMouseOver={() => handleMouseOver(1)}
              >
                <div className="testi-box_content feature-card-active-wrap">
                  <p className="testi-box_text">
                    "The Hunza Cherry Blossom tour was beyond our expectations. Everything was perfectly organized — accommodation, meals, and transport. We will definitely book again!"
                  </p>
                  <div className="testi-box_review">
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                  </div>
                </div>
                <div className="testi-box_profile">
                  <div className="testi-box_avater">
                    <span></span>
                    <img src="/assets/img/testimonial/testi_2_2.png" alt="testimonial" />
                  </div>
                  <div className="media-body">
                    <h3 className="box-title">Sara Malik</h3>
                    <span className="testi-box_desig">Karachi, Pakistan</span>
                  </div>
                </div>
              </div>

              {/* Testimonial 3 */}
              <div
                className={`testi-box hover-item ${activeIndex === 2 ? 'item-active' : ''}`}
                onMouseOver={() => handleMouseOver(2)}
              >
                <div className="testi-box_content feature-card-active-wrap">
                  <p className="testi-box_text">
                    "Our Fairy Meadows trek was an unforgettable adventure. Himolan Peak Adventures handled every detail with care. The campfire evenings with mountain views were truly breathtaking."
                  </p>
                  <div className="testi-box_review">
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                  </div>
                </div>
                <div className="testi-box_profile">
                  <div className="testi-box_avater">
                    <span></span>
                    <img src="/assets/img/testimonial/testi_2_3.png" alt="testimonial" />
                  </div>
                  <div className="media-body">
                    <h3 className="box-title">Usman Tariq</h3>
                    <span className="testi-box_desig">Islamabad, Pakistan</span>
                  </div>
                </div>
              </div>

              {/* Testimonial 4 */}
              <div
                className={`testi-box hover-item ${activeIndex === 3 ? 'item-active' : ''}`}
                onMouseOver={() => handleMouseOver(3)}
              >
                <div className="testi-box_content feature-card-active-wrap">
                  <p className="testi-box_text">
                    "We booked the honeymoon package for Skardu and it was absolutely perfect. The team arranged a luxury vehicle, beautiful hotel, and made every moment special for us."
                  </p>
                  <div className="testi-box_review">
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                  </div>
                </div>
                <div className="testi-box_profile">
                  <div className="testi-box_avater">
                    <span></span>
                    <img src="/assets/img/testimonial/testi_2_4.png" alt="testimonial" />
                  </div>
                  <div className="media-body">
                    <h3 className="box-title">Bilal & Ayesha</h3>
                    <span className="testi-box_desig">Rawalpindi, Pakistan</span>
                  </div>
                </div>
              </div>

              {/* Testimonial 5 */}
              <div
                className={`testi-box hover-item ${activeIndex === 4 ? 'item-active' : ''}`}
                onMouseOver={() => handleMouseOver(4)}
              >
                <div className="testi-box_content feature-card-active-wrap">
                  <p className="testi-box_text">
                    "Highly recommend Himolan Peak Adventures for anyone wanting to explore Northern Pakistan. Transparent pricing, responsive on WhatsApp, and they truly go above and beyond."
                  </p>
                  <div className="testi-box_review">
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                  </div>
                </div>
                <div className="testi-box_profile">
                  <div className="testi-box_avater">
                    <span></span>
                    <img src="/assets/img/testimonial/testi_2_5.png" alt="testimonial" />
                  </div>
                  <div className="media-body">
                    <h3 className="box-title">Kamran Hussain</h3>
                    <span className="testi-box_desig">Peshawar, Pakistan</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Shapes */}
        <div className="shape-mockup movingX d-none d-xl-block" style={{ top: '30%', left: '-9%' }}>
          <img className="gmovingX" src="/assets/img/shape/shape_7.png" alt="shape" />
        </div>
        <div className="shape-mockup spin d-none d-xl-block" style={{ bottom: '30%', right: '-10%' }}>
          <img src="/assets/img/shape/shape_2_5.png" alt="shape" />
        </div>
        <div className="shape-mockup jump d-none d-xl-block" style={{ bottom: '0%', left: '-5%' }}>
          <img src="/assets/img/shape/shape_2_2.png" alt="shape" />
        </div>
      </div>
    </section>
  );
};

export default TestimonialTwo;
